import React, { useContext } from 'react';
import styled from 'styled-components';
import { Tooltip, FlexMiddle } from '@ubeya/shared-web/components';
import { ReactComponent as PayQueryIcon } from '@ubeya/shared-web/assets/payroll-query.svg';
import { ReactComponent as PayrollProcessIcon } from '@ubeya/shared-web/assets/payroll-process.svg';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { PAYROLL_PROCESS_STATUS } from '@ubeya/shared-web/constants';

const Wrapper = styled(FlexMiddle)`
  cursor: default;
  .read-only {
    display: none;
  }
`;

const PayrollProcessRenderer = ({ rowData }) => {
  const { summarized, subRows } = rowData;
  const { t } = useContext(ConfigContext);

  if (summarized || subRows) {
    return <></>;
  }

  const SelectIconPerProcessStatus = () => {
    if (!rowData?.payrollProcess) {
      return <></>;
    }

    if (rowData.payrollProcess?.status === PAYROLL_PROCESS_STATUS.PROCESSED) {
      return (
        <Tooltip body={t('processedTooltip')}>
          <PayrollProcessIcon />
        </Tooltip>
      );
    }

    if (rowData.payrollProcess?.status === PAYROLL_PROCESS_STATUS.PAY_QUERY) {
      return (
        <Tooltip body={t('payQueryTooltip')}>
          <PayQueryIcon />
        </Tooltip>
      );
    }
  };

  return (
    <Wrapper>
      <SelectIconPerProcessStatus />
    </Wrapper>
  );
};

export default PayrollProcessRenderer;
